import { ImagesTable } from './ImagesTable'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { AddImageForm } from '../Forms/AddImageForm'
import { useState, useEffect, useCallback } from 'react'

export const ImageControl = () => {
  const [addImageDrawerOpen, setAddImageDrawerOpen] = useState(false)
  const [refetchImages, setRefetchImages] = useState<() => void>(() => () => {})

  // ✅ Memoized version of the setRefetch function
  const handleSetRefetch = useCallback((refetch: () => void) => {
    setRefetchImages(() => refetch)
  }, [])

  useEffect(() => {
    // Optional: If needed, you can log when refetchImages changes
    console.log('Refetch function updated.')
  }, [refetchImages])

  return (
    <div className="p-5">
      <ImagesTable
        onAdd={() => setAddImageDrawerOpen(true)}
        setRefetch={handleSetRefetch} // ✅ Use the memoized function
      />
      <OverlayDrawerComponent
        open={addImageDrawerOpen}
        setOpen={setAddImageDrawerOpen}
        title="Add Image"
        content={
          <AddImageForm
            onSubmit={() => {
              setAddImageDrawerOpen(false)
              refetchImages() // ✅ Call the updated refetch function
            }}
          />
        }
      />
    </div>
  )
}
